<template>
  <b-container fluid>
    <b-row class="justify-content-md-center">
      <b-col class="my-2" cols=8>
          <b-form @submit="search">
            <b-form-row class="align-items-center mb-2">
              <b-col>
                <label>Product Num</label>
              </b-col>
              <b-col>
                <input type="text" v-model="productNum" class='form-control mb-2 ml-1 mr-2 mb-sm-0' onfocus="this.select();" onmouseup="return false;" />
              </b-col>
              <b-col>
                <label>Product Description</label>
              </b-col>
              <b-col>
                <input type="text" :disabled="exactMatch" v-model="productDesc" class='form-control mb-2 ml-1 mr-2 mb-sm-0' onfocus="this.select();" onmouseup="return false;" />
              </b-col>
              <b-col>
                <b-select v-model="exactMatch" :options="[ { value: false, text: 'Partial Match' }, { value: true, text: 'Exact Match'} ]" />
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col>
                <label>Start Date</label>
              </b-col>
              <b-col>
                <b-input v-model="startDate" type="date" class='mb-2 ml-1 mr-2 mb-sm-0' min="2000-01-01" :max="$moment().format('YYYY-MM-DD')" />
              </b-col>
              <b-col>
                <label>End Date</label>
              </b-col>
              <b-col>
                <b-input v-model="endDate" type="date" class='mb-2 ml-1 mr-2 mb-sm-0' min="2000-01-01" :max="$moment().format('YYYY-MM-DD')" />
              </b-col>
              <b-col>
                <b-button variant="primary" type="submit">Search</b-button>
                <a class="btn btn-info" :href="csvPath">Download CSV</a>
              </b-col>
            </b-form-row>
          </b-form>
      </b-col>
    </b-row>
    <sales-notes :last-reset-date="last_reset_date" :earliest-so-date="earliest_so_date" :kit="kit" :has-results="hasResults" />
    <section v-if="!kit && hasResults">
      <b-row class="justify-content-md-center align-items-center text-center">
        <div class="col">
          <strong>Total Sold Individually:</strong> {{totalIndSold}}
        </div>
        <div class="col">
          <strong>Total Sold in BOMs:</strong> {{totalBomSold}}
        </div>
        <div class="col">
          <strong>Total Sold in KITs:</strong> {{totalKitSold}}
        </div>
        <div class="col">
          <strong>Total Sold Overall:</strong> {{totalSold}}
        </div>
        <div class="col-4">
          <strong>Total Price:</strong> {{totalPrice | formatDollars}}*<br><em>*Total Price does not include parts/products sold as part of BOMs/KITs</em>
        </div>
      </b-row>
      <b-row>
        <b-col>
          <b-table striped :fields="columns" :items="items" class="mt-2 fixed-table">
            <template slot='date' slot-scope='data'>
              <NiceDate :value='String(data.item.date)' :showTime=false :isUtc=true />
            </template>
            <template slot="partnum" slot-scope="data">
              <router-link
                :to="{ name: 'Qty Calculations', query: { partNum: data.item.partnum }}"
                target="_blank"
              >{{ data.item.partnum }}</router-link>
            </template>
            <template slot='qtysold' slot-scope='data'>
              {{data.item.qtysold}}
            </template>
            <template slot='qtysoldinboms' slot-scope='data'>
              <span v-if="data.item.qtysoldinboms > 0" style="color: red;">
                {{data.item.qtysoldinboms}}
              </span>
              <span v-else>
                {{data.item.qtysoldinboms}}
              </span>
            </template>
            <template slot='qtysoldinkits' slot-scope='data'>
              <span v-if="data.item.qtysoldinkits > 0" style="color: red;">
                {{data.item.qtysoldinkits}}
              </span>
              <span v-else>
                {{data.item.qtysoldinkits}}
              </span>
            </template>
            <template slot='qtytotal' slot-scope='data'>
              {{data.item.qtysoldinkits + data.item.qtysoldinboms + data.item.qtysold}}
            </template>
            <template slot='individualsales' slot-scope='data'>
              {{data.item.individualsales | formatDollars}}
            </template>
          </b-table>
        </b-col>
      </b-row>
    </section>
  </b-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import NiceDate from '../utility/NiceDate';
import SalesNotes from './SalesNotes.vue';
import { FingerprintSpinner } from 'epic-spinners';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  components: {
    NiceDate,
    FingerprintSpinner,
    SalesNotes,
  },
  data() {
    return {
      productNum: '',
      productDesc: '',
      startDate: moment("0101" + String(moment().year() - 3),"MMDDYYYY").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      exactMatch: false,
      loading: false,
      hasResults: true,

      columns: [
        { key: 'date', sortable: true },
        { key: 'partnum', sortable: true, label: 'Part Num' },
        { key: 'partdescription', sortable: true, label: 'Part Desc' },
        { key: 'qtysold', sortable: true, label: 'Quantity Sold Individually' },
        { key: 'qtysoldinboms', sortable: true, label: 'Quantity Sold in BOMs' },
        { key: 'qtysoldinkits', sortable: true, label: 'Quantity Sold in KITs' },
        { key: 'qtytotal', sortable: true, label: 'Total Sold' },
        { key: 'uom', sortable: true, label: 'UOM' },
        { key: 'individualsales', sortable: true, label: 'Price' },
      ],
      kit: false,
      items: [],
      last_reset_date: '',
      earliest_so_date: '',
    };
  },
  computed: {
    totalPrice() {
      let prices = this.items.map(x => (x.individualsales > 0 && !isNaN(x.individualsales) ? x.individualsales : 0));
      console.log(prices)
      return prices.reduce((a,v) => a + v, 0.0);
    },
    totalIndSold() {
      let sum = 0;
      this.items.forEach(x => sum += x.qtysold);
      return sum.toLocaleString();
    },
    totalBomSold() {
      let sum = 0;
      this.items.forEach(x => sum += x.qtysoldinboms);
      return sum.toLocaleString();
    },
    totalKitSold() {
      let sum = 0;
      this.items.forEach(x => sum += x.qtysoldinkits);
      return sum.toLocaleString();
    },
    totalSold() {
      let sum = 0
      this.items.forEach(x => sum += x.qtysold + x.qtysoldinboms + x.qtysoldinkits)
      return sum.toLocaleString()
    },
    csvPath() {
      return `${BASE_API}/inventory-sales-history/sales-data.csv?id=${this.productNum}&start=${this.startDate}&end=${this.endDate}&desc=${encodeURI(this.productDesc)}&exact=${this.exactMatch ? 'true' : 'false'}`
    }
  },
  mounted() {
    axios.get(`${BASE_API}/inventory-sales-history/config-stats`).then(response => {
      this.last_reset_date = response.data.find(x => x.field == 'last_reset_date').data;
      this.earliest_so_date = response.data.find(x => x.field == 'earliest_so_date').data;
    }).catch((error) => {
      console.error(error);
    });
  },
  methods: {
    checkKit() {
      this.kit = false;
      axios({
        method: 'post',
        url: `${BASE_API}/ams3-fishioninfo/part-info/search`,
        data: {
          exactMatch: true,
          productNum: this.productNum
        }
      }).then(response => {
        if (response.data.length > 0) {
          this.kit = response.data[0].item_type == 'Kit';
        }
      }).catch((error) => {
        console.error(error);
      });
    },
    search(event) {
      event.preventDefault();
      this.loading = true;
      this.hasResults = true;
      if (this.exactMatch) {
        this.checkKit();
      }
      axios.get(`${BASE_API}/inventory-sales-history/sales-data?id=${this.productNum}&start=${this.startDate}&end=${this.endDate}&desc=${encodeURI(this.productDesc)}&exact=${this.exactMatch ? 'true' : 'false'}`)
        .then(response => {
          this.items = response.data;
          if (this.items.length == 0)
            this.hasResults = false;
        })
        .catch((error) => {
          console.error(error);
          this.hasResults = false;
        })
        .finally(() => {
          this.loading = false
        }
      );
    },
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/purchasing/SalesData.vue